<div style="padding:30px">
    <div class="datebg">
        <div class="card text-white bg-light mb-3 info_item" style="margin-top:10px" *ngIf="now != '8'">
          <div class="card-header">
            區間數據
            <input type="text"
            *ngIf="time"
            class="form-control"
            ngxDaterangepickerMd
            [(ngModel)]="time"
            [autoApply]="true"
            [ranges]="ranges" [alwaysShowCalendars]="true"
            [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD'}"
            [opens]="'right'"
            [minDate]="time.minDate"
            [maxDate]='time.maxDate'
            (change)="onRangeSelected(1,$event)"
            (blur)="onDateTyped($event)"
            style="width: 260px;display: inline-block;margin-right: 16px;"
            ></div>
          <div class="card-body" *ngIf="now=='1'">
            <div class="card-text top_info_num">標準：<span class="show_it">{{top_info.secs}}秒</span></div>
            <div class="card-text top_info_num" *ngIf="!top_info.data ||top_info.data.length==0">當前過慢api：<span class="show_it">無</span><div class="tips">2小時內超過標準的會列出</div></div>
            <div class="card-text top_info_num" *ngIf="top_info.data &&  top_info.data.length>0" style="overflow: auto;max-height: 150px;">當前過慢api：
                <div class="tips">2小時內超過標準的會列出</div>
                <div *ngFor="let path of top_info.data;let bi = index" >
                    {{path.path}}：{{path.avg_res_time}}
                </div>
            </div>
          </div>
          <div class="card-body" *ngIf="now=='2'">
            <div class="card-text top_info_num">標準：<span class="show_it">ping值超過{{top_info.ping}}</span></div>
            <div class="card-text top_info_num" *ngIf="!top_info.data ||top_info.data.length==0">ping值過高：<span class="show_it">無</span></div>
            <div class="card-text top_info_num" *ngIf="top_info.data &&  top_info.data.length>0" style="overflow: auto;max-height: 150px;">
                <div *ngFor="let path of top_info.data;let bi = index" >
                    {{path.name}}：{{path.num|number}}次
                </div>
            </div>
          </div>
        </div>
        <hr>
        <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
            <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
              <span   [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
            </li>
        </ul>
    </div>





    <div *ngIf="now=='1'">
        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.tab_status"
        (change)="init_list()"
        >
        <option *ngFor="let item of tab_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <table class="table table-responsive-sm" *ngIf="data.length>0">
            <thead>
                <tr class="table-primary">
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'target_date')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('target_date',sort_obj.sort)">日期</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'h')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('h',sort_obj.sort)">時間點</th>
                    <th>tab頁</th>
                    <th>路徑</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'avg_res_time')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('avg_res_time',sort_obj.sort)">平均響應時間</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'min_res_time')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('min_res_time',sort_obj.sort)">最小響應時間</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'max_res_time')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('max_res_time',sort_obj.sort)">最大響應時間</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'times')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('times',sort_obj.sort)">呼叫次數</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                    <td>{{item.target_date}}</td>
                    <td>{{item.h}}</td>
                    <td>{{item.tab_name}}</td>
                    <td>{{item.path}}</td>
                    <td>{{item.avg_res_time|number}}</td>
                    <td>{{item.min_res_time|number}}</td>
                    <td>{{item.max_res_time|number}}</td>
                    <td>{{item.times|number}}</td>
     
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="now=='2'">
        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.server_status"
        (change)="init_list()"
        >
        <option *ngFor="let item of server_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <table class="table table-responsive-sm" *ngIf="data.length>0">
            <thead>
                <tr class="table-primary">
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'create_dt')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('create_dt',sort_obj.sort)">時間</th>
                    <th>出發位置</th>
                    <th>節點數</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'last_ping')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('last_ping',sort_obj.sort)">最後ping值</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'high_loss_value')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('high_loss_value',sort_obj.sort)">最高節點封包掉落率</th>
                    <th>區域</th>
                    <th>下載數據</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                    <td>{{item.create_dt}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.all_node_count}}</td>
                    <td>{{item.last_ping}}</td>
                    <td>{{item.high_loss_value}}</td>
                    <td>{{item.high_stdev_from}}</td>
                    <td>
                        <a href="{{urltoken}}&ggwp={{item.id}}" target="_blank">
                            <i style="margin-right:10px" class="fas fa-chart-line"></i>
                        </a>
                        </td>
    
                    </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="now=='3'">
        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.tab_status"
        (change)="init_list()"
        >
        <option *ngFor="let item of tab_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.path_status"
        (change)="init_list()"
        >
        <option *ngFor="let item of path_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <input type="text" placeholder="查詢使用者"  style="width: 160px;display: inline-block;"  
        class="form-control"  [(ngModel)]="tool_obj.search_model"  
        (keyup.enter)="init_list()">
        <button class="btn btn-primary" (click)="init_list()">確認</button>
        <table class="table table-responsive-sm" *ngIf="data.length>0">
            <thead>
                <tr class="table-primary">
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'target_date')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('target_date',sort_obj.sort)">日期</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'h')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('h',sort_obj.sort)">時間點</th>
                    <th>用戶</th>
                    <th>大頭</th>
                    <th>類型</th>
                    <th>tab頁</th>
                    <th>路徑</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'times')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('times',sort_obj.sort)">次數</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                    <td>{{item.target_date}}</td>
                    <td>{{item.h}}</td>
                    <td>
                        <a target="_blank" href="{{link}}/useractive/{{item.uid}}"><span class="user_identity_{{item.identity}}">{{item.name}}
                            <div *ngIf="item.v_name && item.v_name.length>0">({{item.v_name}})</div>
                          </span></a>
                    </td>
                    <td>
                        <img loading="lazy" style="height: 60px;" src="{{item.profile_pic}}">
                    </td>
                    <td>{{item.tname}}</td>
                    <td>{{item.tab_name}}</td>
                    <td>{{item.path}}</td>
                    <td>{{item.times|number}}次</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="now=='4'">
        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.tab_status"
        (change)="init_list()"
        >
        <option *ngFor="let item of tab_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.path_status"
        (change)="init_list()"
        >
        <option *ngFor="let item of path_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <input type="text" placeholder="查詢使用者"  style="width: 160px;display: inline-block;"  
        class="form-control"  [(ngModel)]="tool_obj.search_model"  
        (keyup.enter)="init_list()">
        <button class="btn btn-primary" (click)="init_list()">確認</button>
        <table class="table table-responsive-sm" *ngIf="data.length>0">
            <thead>
                <tr class="table-primary">
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'create_dt')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('create_dt',sort_obj.sort)">日期</th>
                    <th>用戶</th>
                    <th>大頭</th>
                    <th>類型</th>
                    <th>tab頁</th>
                    <th>路徑</th>
                    <th>app紀錄時間</th>
                    <th>server響應時間</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                    <td>{{item.create_dt}}</td>
                    <td>
                        <a target="_blank" href="{{link}}/useractive/{{item.uid}}"><span class="user_identity_{{item.identity}}">{{item.name}}
                            <div *ngIf="item.v_name && item.v_name.length>0">({{item.v_name}})</div>
                          </span></a>
                    </td>
                    <td>
                        <img loading="lazy" style="height: 60px;" src="{{item.profile_pic}}">
                    </td>
                    <td>{{item.tname}}</td>
                    <td>{{item.tab_name}}</td>
                    <td>{{item.path}}</td>
                    <td>{{item.res_time}}秒</td>
                    <td>
                        <span *ngIf="item.server_time*1==0">尚未比對</span>
                        <span *ngIf="item.server_time*1==-1">查無資料</span>
                        <span *ngIf="item.server_time*1>0">{{item.server_time}}秒</span>

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="now=='6' && !loading">
        <highcharts-chart  [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="lineOptions"  style="display: block;width: 65%;margin:6px"></highcharts-chart>
    </div>

    <div *ngIf="now=='7'">
        
        是否有用vpn：
   
        <select class="form-control"
            style="width: 160px;display: inline-block;margin-bottom: 2%;"
            [(ngModel)]="tool_obj.vpn_status"
            (change)="init_list()"
        >
            <option *ngFor="let item of vpn_status_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <input type="text" placeholder="查詢使用者"  style="width: 160px;display: inline-block;margin-bottom: 2%;margin-left: 2%;"  class="form-control"  [(ngModel)]="tool_obj.search_model"  (keyup.enter)="init_list()">

        <app-table-v2 [type]="1" [data]="data"  [tcontent]="tcontent" *ngIf="data.length>0"  (sortdata)="handlesortdata($event)">
            
            <ng-template let-post #operation_dk>

                <div *ngIf="post.key == 'gender'">
                    <span *ngIf="post.val.gender==1">男</span>
                    <span *ngIf="post.val.gender==2">女</span>         
                    <span *ngIf="post.val.gender==3">不限(官方帳號)</span>         
                </div>
                
                <div *ngIf="post.key == 'vpn'">
                    <span *ngIf="post.val.vpn==0">否</span>
                    <span *ngIf="post.val.vpn==1">是</span>         
                </div>

                <div *ngIf="post.key == 'gg'">
                    <a href="javascript:void(0)" title="查看"  (click)="checklist(post.val)" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-wrench"></i>
                    </a>
                </div>
        
            </ng-template> 
    
        </app-table-v2>


    </div>


    <div *ngIf="now=='5' && !loading">
        <div  style="margin: 10px" >
            <bitton class="btn"  [ngClass]="tool_obj.sub_server_menu=='1'?'btn-danger':'btn-dark'"   (click)="tool_obj.sub_server_menu='1'">圖</bitton>
            <bitton class="btn"  [ngClass]="tool_obj.sub_server_menu=='2'?'btn-danger':'btn-dark'"   (click)="tool_obj.sub_server_menu='2'">數據</bitton>
        </div>

        <div  style="margin: 10px;min-height: 400px;" *ngIf="tool_obj.sub_server_menu=='1'">
            <div>server load
                <div class="tips"><a href="https://ithelp.ithome.com.tw/questions/10001261" target="_blank">load average 若大於5是很忙碌;若小於3則很輕</a></div>
            </div>
            <highcharts-chart  [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="lineOptions"  style="display: block;width: 65%;margin:6px"></highcharts-chart>
            <div>server ram used</div>
            <highcharts-chart  [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="lineOptions2"  style="display: block;width:65%;margin:6px"></highcharts-chart>
        </div>
        <div *ngIf="tool_obj.sub_server_menu=='2'">
            <select class="form-control"
            style="width: 160px;display: inline-block;"
            [(ngModel)]="tool_obj.server_status2"
            (change)="init_list()"
            >
            <option *ngFor="let item of server_option_list2" [ngValue]="item.id">{{item.name}}</option>
            </select>
            <table class="table table-responsive-sm" *ngIf="data.length>0">
                <thead>
                    <tr class="table-primary">
                        <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'statistics_date')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('statistics_date',sort_obj.sort)">時間</th>
                        <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'statistics_hour')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('statistics_date',sort_obj.statistics_hour)">小時</th>
                        <th>server</th>
                        <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'load_min')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('load_min',sort_obj.sort)">min_load</th>
                        <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'load_average')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('load_average',sort_obj.sort)">avg_load</th>
                        <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'load_max')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('load_max',sort_obj.sort)">max_load</th>
                        <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'ram_usage_min')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('ram_usage_min',sort_obj.sort)">min_ram_used</th>
                        <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'ram_usage_average')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('ram_usage_average',sort_obj.sort)">avg_ram_used</th>
                        <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'ram_usage_max')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('ram_usage_max',sort_obj.sort)">max_ram_used</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                        <td>{{item.statistics_date}}</td>
                        <td>{{item.statistics_hour}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.load_min}}</td>
                        <td>{{item.load_average}}</td>
                        <td>{{item.load_max}}</td>
                        <td>{{item.ram_usage_min}}</td>
                        <td>{{item.ram_usage_average}}</td>
                        <td>{{item.ram_usage_max}}</td>
                    </tr>
                </tbody>
            </table>

        </div>
        
    </div>
    <app-pagnation *ngIf="!(now=='5' && tool_obj.sub_server_menu==1)" (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    <div *ngIf="data.length==0 && now != '6' && now !='8' && now !='5'">無資料</div>

    <div *ngIf="now=='8' && !loading">

        <div  style="margin: 10px" >
            <bitton class="btn"  [ngClass]="tool_obj.sub_server_api=='1'?'btn-info':'btn-dark'"   (click)="tool_obj.sub_server_api='1';this.init_list()" style="margin-right: 1%;">日</bitton>
            <bitton class="btn"  [ngClass]="tool_obj.sub_server_api=='2'?'btn-info':'btn-dark'"   (click)="tool_obj.sub_server_api='2';this.init_list()" style="margin-right: 1%;">時</bitton>
            <bitton class="btn"  [ngClass]="tool_obj.sub_server_api=='3'?'btn-info':'btn-dark'"   (click)="tool_obj.sub_server_api='3';this.init_list()" style="margin-right: 1%;">分</bitton>
        </div>

        <div  style="margin: 10px;min-height: 400px;">              
            <highcharts-chart  [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="lineOptions"  style="display: block;width: 65%;margin:6px"></highcharts-chart>
        </div>       
    </div>

</div>

<div 
*ngIf="edit_data"
class="modal fade bd-example-modal-lg" tabindex="-1"
 role="dialog"  data-keyboard="false" data-backdrop="static" 
 aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
 >
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="now=='2'">

      <div class="modal-body" style="white-space: pre-wrap;"> 
        {{edit_data.raw_record}}
      </div>

      <div class="modal-footer">
          <button type="button"  (click)="init_list()" class="btn btn-danger" data-dismiss="modal">確定</button>
      </div>
    </div>
  </div>
</div>
<div 
*ngIf="edit_data"
class="modal fade bd-example-modal-xl" tabindex="-1"
role="dialog"  data-keyboard="false" data-backdrop="static" 
aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title">查看</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
  
            <!-- Modal body -->
            <div class="modal-body">                          
                <app-table-v2 [type]="1" [data]="datadetail"  [tcontent]="tcontentdetail" *ngIf="datadetail.length>0">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'traceInfos'"> 
                            <a href="javascript:void(0)" title="查看連結" (click)="click(post.val.traceInfos);">
                                <i style="margin: 0 10px 0 0;" class="fas fa-book"></i>
                            </a>
                        </div>
                    </ng-template> 
                </app-table-v2>
                <app-pagnation  (callback)="callback1($event)" [data]="pageobjstr1"></app-pagnation> 
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button id="ModalClose" type="button" class="btn btn-danger" data-dismiss="modal">關閉</button>
            </div>
        </div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>